import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import UnauthenticatedLayout from './UnauthenticatedLayout';
import { SuccessLoginData } from '../../types/general.types';

const Landing = React.lazy(() => import('./Landing'));
const CreateAccount = React.lazy(() => import('../auth/CreateAccount'));
const ForgotPassword = React.lazy(() => import('../auth/ForgotPassword'));
const CreatePassword = React.lazy(() => import('../auth/CreatePassword'));
const ResetPassword = React.lazy(() => import('../auth/ResetPassword'));
const Login = React.lazy(() => import('../auth/Login'));

interface Props {
  setLoginData: (data: SuccessLoginData) => void;
}

export default function UnauthenticatedRoutes({ setLoginData }: Props) {
  return (
    <Routes>
      <Route path='/' element={<UnauthenticatedLayout />}>
        <Route index element={<Landing />} />
        <Route path='/login' element={<Login setLoginData={setLoginData} />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/create-password' element={<CreatePassword />} />
        <Route path='/reset-password' element={<ResetPassword />} />
        <Route path='/create-account' element={<CreateAccount />} />
      </Route>
      <Route path='*' element={<Navigate to='/' />} />
    </Routes>
  );
}
